exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cell[data-v-2df633e3] {\n  height: 0.8rem;\n  padding: 0.75rem 0.5rem 0.9rem 0.5rem;\n}\n.cell .title[data-v-2df633e3] {\n  text-indent: 0.4rem;\n}\n.cell .title[data-v-2df633e3]::before {\n  content: \"\";\n  width: 0.15rem;\n  height: 0.8rem;\n  left: 0;\n  top: 0.2rem;\n  position: absolute;\n  background: #333;\n}", ""]);

// exports
